import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import type { AnalysisData } from './analysisTypes';

interface StageResultsTableProps {
  analysis: AnalysisData;
  stageNumber: number;
}

const fmt = (v: number | null, decimals = 2): string =>
  v != null ? v.toFixed(decimals) : '—';

const cellSx = { fontSize: '0.8rem', py: 0.75 };
const headerSx = { ...cellSx, fontWeight: 700 };

export const StageResultsTable = ({ analysis, stageNumber }: StageResultsTableProps) => {
  const hasData =
    analysis.peakShearStress != null || analysis.residualShearStress != null;

  if (!hasData) return null;

  return (
    <TableContainer sx={{ mb: 2 }}>
      <Typography variant="subtitle2" sx={{ mb: 0.5, fontSize: '0.82rem', fontWeight: 700 }}>
        Stage {stageNumber} Summary Values
      </Typography>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell sx={headerSx} />
            <TableCell sx={headerSx} align="right">Shear Stress (kPa)</TableCell>
            <TableCell sx={headerSx} align="right">Normal Stress (kPa)</TableCell>
            <TableCell sx={headerSx} align="right">H Displacement (mm)</TableCell>
            <TableCell sx={headerSx} align="right">Friction Angle (°)</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell sx={{ ...cellSx, fontWeight: 600, color: '#FFC000' }}>Peak</TableCell>
            <TableCell sx={cellSx} align="right">{fmt(analysis.peakShearStress)}</TableCell>
            <TableCell sx={cellSx} align="right">{fmt(analysis.peakNormalStress)}</TableCell>
            <TableCell sx={cellSx} align="right">{fmt(analysis.peakHorizontalDisp, 3)}</TableCell>
            <TableCell sx={cellSx} align="right">{fmt(analysis.peakFrictionAngle)}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell sx={{ ...cellSx, fontWeight: 600, color: '#FF0000' }}>Residual</TableCell>
            <TableCell sx={cellSx} align="right">{fmt(analysis.residualShearStress)}</TableCell>
            <TableCell sx={cellSx} align="right">{fmt(analysis.residualNormalStress)}</TableCell>
            <TableCell sx={cellSx} align="right">{fmt(analysis.residualHorizontalDisp, 3)}</TableCell>
            <TableCell sx={cellSx} align="right">{fmt(analysis.residualFrictionAngle)}</TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
};
